import EmajinWhatIsImage from './emajin-what-is.webp'
import EmajinWhatIsIconsImage from './emajin-what-is-icons.webp'
import EmajinWhoIsImage from './emajin-who-is.webp'
import EmajinWhoIsIconsImage from './emajin-who-is-icons.webp'
import EmajinWhyJoinImage from './emajin-why-join.webp'
import EmajinWhyJoinIconsImage from './emajin-why-join-icons.webp'
import GolfFieldImage from './golf-field.webp'

export {
  EmajinWhatIsIconsImage,
  EmajinWhatIsImage,
  EmajinWhoIsIconsImage,
  EmajinWhoIsImage,
  EmajinWhyJoinIconsImage,
  EmajinWhyJoinImage,
  GolfFieldImage,
}
